import { render, staticRenderFns } from "./edit_user.vue?vue&type=template&id=6097a474&"
import script from "./edit_user.vue?vue&type=script&lang=js&"
export * from "./edit_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports